const d = ["#006837", "#66bd63", "#fee08b", "#f46d43", "#a50026"], E = [
  "#006837",
  "#66bd63",
  "#a6d96a",
  "#fee08b",
  "#f46d43",
  "#a50026"
], _ = [
  "#006837",
  "#66bd63",
  "#a6d96a",
  "#fee08b",
  "#f46d43",
  "#d73027",
  "#a50026"
], a = [
  "#006837",
  "#1a9850",
  "#66bd63",
  "#a6d96a",
  "#fee08b",
  "#f46d43",
  "#d73027",
  "#a50026"
], e = [
  "#006837",
  "#1a9850",
  "#66bd63",
  "#a6d96a",
  "#d9ef8b",
  "#fee08b",
  "#f46d43",
  "#d73027",
  "#a50026"
], f = [
  "#006837",
  "#1a9850",
  "#66bd63",
  "#a6d96a",
  "#d9ef8b",
  "#fee08b",
  "#fdae61",
  "#f46d43",
  "#d73027",
  "#a50026"
];
export {
  f as HEAT_MAP_GREEN_RED_10,
  d as HEAT_MAP_GREEN_RED_5,
  E as HEAT_MAP_GREEN_RED_6,
  _ as HEAT_MAP_GREEN_RED_7,
  a as HEAT_MAP_GREEN_RED_8,
  e as HEAT_MAP_GREEN_RED_9
};
//# sourceMappingURL=index.es5675.js.map
